<app-share-button ></app-share-button>

<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>परिचय 
                    </h2>
                </div>
                <!-- <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div> -->
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">

                </div>
                <div class="col-md-12 mt-2" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2> </h2>
                    <label for="" class="mt-2">यह दस्तावेज़ PayG रेसलर प्लेटफ़ॉर्म में लॉगिन करने के लिए विस्तृत कदमों को बताता है। कृपया इन निर्देशों का ध्यानपूर्वक पालन करें ताकि आप सफलतापूर्वक लॉगिन कर सकें। </label>
                </div>
                <div class="col-md-12 mt-2  " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">


                    <h4 class="mt-4"><b>स्टेप 1: हमारी वेबसाइट पर जाएं <a> www.payg.in </a> और "Reseller" के रूप में लॉगिन करने के लिए क्लिक करें। </b>
                    </h4>
                    <label for=""></label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                             <img src=" ./assets/rr-otp(1).svg" width="100%" height="100%" alt="">
                        </div>
                    </div>


                    <h4 class="mt-4"><b>स्टेप 2: अपनी ईमेल/फोन और पासवर्ड दर्ज करें </b></h4>
                    <label for="">अपनी ईमेल/फोन और पासवर्ड दर्ज करें, फिर "Login" पर क्लिक करें </label>


                    <div class="row">
                        <div class="col-md-12 mt-3">
                             <img src=" ./assets/rr-top(2).svg" width="100%" height="100%" alt=""> 
                        </div>
                    </div>

                    <h4 class="mt-4"><b>स्टेप 3: आपका OTP आपके PayG RMS ऐप पर भेजा जाएगा  </b></h4>
                    <label for="">आपको आपका OTP PayG RMS ऐप पर भेजा जाएगा। अगर आपके पास ऐप नहीं है, तो पहले PayG RMS ऐप डाउनलोड करें, फिर ऐप में लॉगिन करें और OTP प्राप्त करें</label>

                    <div class="row">
                        <div class="col-md-12 mt-3">
                             <img src="./assets/Screenshot 2024-10-30 123903.png" width="100%" height="100%" alt=""> 
                            <label class="mt-2 mb-2">PayG RMS ऐप को प्ले स्टोर या एप स्टोर से डाउनलोड करें  </label>

                        </div>
                    </div>

                    <h4 class="mt-5"><b>स्टेप 4: OTP के लिए ऐप चेक करें </b></h4>
                    <label for="">जब आप अपने ऐप में लॉगिन करेंगे, तो ऐप में एक पॉप-अप नोटिफिकेशन के साथ आपका OTP सीधे दिखाई देगा। </label>

                    <div class="row">
                        <div class="col-md-12 mt-3" style="text-align: center;">
                             <img src=" ./assets/rr-otp(4).svg" width="200px" height="400px" alt="">
                        </div>
                    </div>

                    <h4 class="mt-4"><b>स्टेप 5: OTP दर्ज करें</b></h4>

                    <label for="">आपको जो OTP आपके ऐप पर प्राप्त हुआ है, उसे वेब पर लॉगिन करने के लिए दर्ज करें </label>


                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src=" ./assets/rr-orp(5).svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <h4 class="mt-4">OTP दर्ज करने के बाद, आप अपने डैशबोर्ड में लॉगिन हो जाएंगे। </h4>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src=" ./assets/rr-otp(6).svg" width="100%" height="100%" alt=""> 
                        </div>
                    </div>
                    <h4 class="mt-4"> 

                        नोट: अगर आपको डैशबोर्ड पर OTP नहीं दिख रहा है, तो बाएं तरफ प्रोफाइल पर क्लिक करें और फिर "View OTP" पर क्लिक करें। </h4>
                    <div class="row">
                        <div class="col-md-12 mt-3" style="text-align: center;">
                            <img src=" ./assets/rr-otp(7).svg" width="200px" height="400px" alt=""> 
                        </div>
                    </div>

                    <label class="mt-3">अब आपने PayG RMS प्लेटफ़ॉर्म पर ऐप का उपयोग करके लॉगिन प्रक्रिया को सफलतापूर्वक पूरा कर लिया है। अगर आपको कोई समस्या आती है, तो कृपया ऐप के सपोर्ट सेक्शन को देखें या सहायता के लिए कस्टमर सपोर्ट से संपर्क करें। </label>


                </div>
            </div>
        </div>
    </div>

    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची:                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">परिचय </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    ओटीपी के साथ लॉगिन प्रक्रिया</span>

                            </div>
                        </div>
                    </a>
                </div>
                <!-- <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">Benefits of Being a Reseller </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')"> How Resellers Can Benefit from PayG</span>

                            </div>
                        </div>
                    </a>
                </div> -->

            </div>
        </div>
    </div>

    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8    ">
                <a [routerLink]="['/login-with-qr']"><button class="btn btn-color"
                        (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt=""> &nbsp;QR से लॉगिन करें
                        &nbsp;</button></a>
            </div>
            <!-- <div class="col-md-4    ">
                <a [routerLink]="['/registration-process']"> <button class="btn btn-color">Registration paocess
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div> -->
        </div>
    </div>
</div>